import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, Button, ListItemText } from 'components/ui';
import { ArrowDropDownIcon, ArrowDropUpIcon, SettingsIcon, LogoutIcon, PersonIcon, SwapHorizIcon } from 'components/uiIcons'
import { useQuery, useMutation } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { ProfileLink, SpacesLink } from 'utils/link';
import { ListMenuItem } from 'components/styles_components/menu';
import { removeAuthenticated } from 'utils/authentication';
import { useSpace } from 'contexts/space';
import { useError } from 'contexts/error';
import LogoutMutation from 'mutations/user/logout';
import ProfileQuery from 'queries/user/header';
import theme from 'theme';
import { LimitedSpan } from 'components/styles_components/span';

const ProfileButton = () => {
  const [profileAnchorEl, setProfileAnchorEl] = useState(null);
  const profileOpen = Boolean(profileAnchorEl);
  const setError = useError();
  const navigate = useNavigate();
  const { clearSpace } = useSpace();
  const [logout, logoutMutationData] = useMutation(LogoutMutation, {
    onCompleted: () => {
      removeAuthenticated();
    },
  });
  const { data = { user: { email: '...'} }, loading, } = useQuery(ProfileQuery, {
    fetchPolicy: 'cache-first',
    onError: () => {
      setError('error.user.profile.show');
    },
  });

  const handleProfileClick = (event) => {
    setProfileAnchorEl(event.currentTarget);
  };

  const handleProfileClose = () => {
    setProfileAnchorEl(null);
  };

  const onItemClick = (link) => {
    handleProfileClose()
    navigate(link);
  };

  const userName = useMemo(() => {
    if (data.user.name || data.user.surname) {
      return `${data.user.name} ${data.user.surname}`;
    }
    return data.user.email;
  }, [data.user]);

  const icon = useMemo(() => {
    return profileOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />;
  }, [profileOpen]);

  return (
    <>
      <Button
        loading={loading}
        sx={{
          backgroundColor: profileOpen ? theme.palette.custom.whiteGreen : 'transparent'
        }}
        onClick={handleProfileClick}>
        <PersonIcon sx={{ mr: 1 }}/> <LimitedSpan>{userName}</LimitedSpan> {icon}
      </Button>
      <Menu anchorEl={profileAnchorEl} open={profileOpen} onClose={handleProfileClose}>
        <ListMenuItem onClick={() => onItemClick(ProfileLink())}>
          <SettingsIcon sx={{ mr: 2 }} />
          <ListItemText>
            <FormattedMessage id='navbar.profile' />
          </ListItemText>
        </ListMenuItem>
        <ListMenuItem onClick={() => { handleProfileClose(); clearSpace(); navigate(SpacesLink()); }}>
          <SwapHorizIcon sx={{ mr: 2 }} />
          <ListItemText>
            <FormattedMessage id='spaces.change' />
          </ListItemText>
        </ListMenuItem>
        <ListMenuItem onClick={logout} disabled={logoutMutationData.loading}>
          <LogoutIcon sx={{ mr: 2 }} />
          <ListItemText>
            <FormattedMessage id='navbar.logout' />
          </ListItemText>
        </ListMenuItem>
      </Menu>
    </>
  );
};

export default ProfileButton;
